module.exports = __webpack_public_path__ + "img/logo.ae39b83b.png";